<template>
    <div class="contain_white">
        <MyTransition :myName="'up'">
            <Popup v-if="popupStatus">
                <PopupSuccess
                    v-if="popup == 'success'"
                    :text="successText"
                    @check="poupupEnter"
                ></PopupSuccess>
                <PopupError
                    v-if="popup == 'error'"
                    :text="successText"
                    @check="poupupEnter"
                ></PopupError>
            </Popup>
        </MyTransition>
        <div class="password_input">
            <input
                type="password"
                placeholder="填寫舊密碼"
                v-model="password"
                class="input_primary"
            />
        </div>
        <div class="new_password_input">
            <input
                type="password"
                placeholder="輸入新密碼"
                v-model="newPassword"
                class="input_primary"
            />
        </div>
        <div class="re_password_input flex">
            <input
                type="password"
                placeholder="再次輸入新密碼"
                v-model="rePassword"
                class="input_primary"
            />
            <div class="icon">
                <MyTransition :myName="'left'">
                    <i
                        class="el-icon-success green"
                        v-if="passowordCheck && rePassword"
                        key="success"
                    ></i>
                    <i
                        class="el-icon-error red"
                        v-else-if="!passowordCheck && rePassword"
                        key="error"
                    ></i>
                </MyTransition>
            </div>
        </div>
        <div class="password_btn flex">
            <button class="btn_primary" @click="enter">送出修改</button>
        </div>
    </div>
</template>

<style lang="scss">
.password_input,
.new_password_input,
.re_password_input {
    width: 100%;
}
.new_password_input {
    margin: 20px 0;
}
.re_password_input {
    align-items: center;
    .icon {
        i {
            margin: 0 0 0 10px;
        }
        .green {
            color: var(--green);
        }
        .red {
            color: var(--red);
        }
    }
}

.password_btn {
    justify-content: center;
    width: 100%;
    margin-top: 30px;
    button {
        max-width: 200px;
    }
}
</style>

<script>
export default {
    name: "password",
    data() {
        return {
            password: null,
            newPassword: null,
            rePassword: null,
            popupStatus: false,
            successText: null,
            popup: null
        };
    },
    computed: {
        passowordCheck() {
            if (this.newPassword == this.rePassword) {
                return true;
            } else {
                return false;
            }
        }
    },
    methods: {
        enter() {
            this.$http.api.login
                .passwordDeprartment(this.$store.state.user.id, {
                    old_password: this.password,
                    password: this.newPassword
                })
                .then(res => {
                    if (res.status == "200") {
                        this.popupStatus = true;
                        this.popup = "success";
                        this.successText = "修改成功";
                    } else if (res.status == "400") {
                        this.popupStatus = true;
                        this.popup = "error";
                        this.successText = "舊密碼錯誤";
                    }
                })
                .catch(error => {
                    this.popupStatus = true;
                    this.popup = "error";
                    this.successText = "修改失敗";
                });
        },
        poupupEnter() {
            this.popupStatus = false;
            if (this.popup == "success") {
                this.$store.commit("removeToken");
                this.$router.push("/");
            }
        }
    }
};
</script>
